/**
 * Cierra la cookie de los archivos subidos (/api/uploads) en el servidor, al cerrar sesión. La cookie es HttpOnly: el navegador
 * no deja que la página la borre, por eso se le pide al servidor (POST /api/auth/salir, que responde con el pedido de borrado).
 * Se espera la respuesta un instante (máx. 1,5 s) porque, si la página se va antes, el navegador puede no procesar el Set-Cookie.
 * Nunca rompe el cierre de sesión: si falla, la cookie igual deja de servir cuando la sesión se vence o se revoca.
 */
const API_URL = process.env.REACT_APP_API_URL;
const ESPERA_MAX_MS = 1500;

export async function cerrarCookieArchivos(fetchFn = (typeof fetch === 'function' ? fetch : null)) {
  if (!fetchFn) return false;
  try {
    const pedido = fetchFn(`${API_URL}/auth/salir`, { method: 'POST', credentials: 'same-origin' });
    const limite = new Promise((resolver) => setTimeout(() => resolver('limite'), ESPERA_MAX_MS));
    const r = await Promise.race([pedido, limite]);
    return r !== 'limite' && !!(r && r.ok);
  } catch (e) {
    return false;
  }
}
